type SessionMeta = {
  isSessionTemporarilyDisabled?: boolean | null;
  isInActiveRoom?: boolean | null;
} | null | undefined;

export const isUserSessionDisabled = (appMeta?: SessionMeta): boolean =>
  appMeta?.isSessionTemporarilyDisabled === true || appMeta?.isInActiveRoom === true;
